import * as React from 'react';
var LoadingAlignment = function (props) { return (React.createElement("div", { className: "flex flex-col items-center justify-center" },
    React.createElement("div", { className: "relative inline-block h-16 w-16 mobile:h-8 mobile:w-8" }),
    props.text && React.createElement("p", { className: "pt-5 text-center text-[18px] font-semibold" }, props.text))); };
export default LoadingAlignment;
